import $ from 'jquery';

const openCartButton = $('#open-cart-btn');
const sidebarCart = $('.SidebarCart');
let lastFocusedElement = null;
let couponPanelOpen = false;

const announce = (message = '') => {
    sidebarCart.find('[data-sidebar-cart-status]').text(message);
};

const setCouponPanelState = (isOpen, focusInput = false) => {
    couponPanelOpen = Boolean(isOpen);

    const coupon = sidebarCart.find('[data-cart-coupon]');
    const toggle = coupon.find('.SidebarCart__couponToggle');
    const form = coupon.find('.SidebarCart__couponForm');

    coupon.toggleClass('is-open', couponPanelOpen);
    toggle.attr('aria-expanded', couponPanelOpen ? 'true' : 'false');
    coupon.find('.SidebarCart__couponSymbol').text(couponPanelOpen ? '−' : '+');
    form.prop('hidden', !couponPanelOpen);

    if (couponPanelOpen && focusInput) {
        window.setTimeout(() => form.find('.SidebarCart__couponInput').trigger('focus'), 0);
    }
};

const showCouponError = (message) => {
    const status = sidebarCart.find('.SidebarCart__couponStatus');
    status.text(message).prop('hidden', false);
    announce(message);
};

const getAjaxMessage = (response, fallback) => {
    if (response && response.data && response.data.message) {
        return response.data.message;
    }

    if (response && response.responseJSON && response.responseJSON.data) {
        return response.responseJSON.data.message || fallback;
    }

    return fallback;
};

const updateHeaderCartIndicators = (itemCount) => {
    const count = Number(itemCount) || 0;
    const indicators = $('.CartIndicator');

    indicators
        .toggleClass('is-empty', count < 1)
        .attr('aria-hidden', count > 0 ? 'false' : 'true')
        .attr('aria-label', `Liczba produktów w koszyku: ${count}`);
    indicators.find('.CartIndicator__dot').text(count);
};

export const handleOpenCart = (event) => {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }

    if (!sidebarCart.hasClass('active')) {
        lastFocusedElement = document.activeElement;
    }

    sidebarCart.addClass('active').attr('aria-hidden', 'false');
    $('#main-content').addClass('blured');
    document.documentElement.classList.add('SidebarCart-is-open');

    window.setTimeout(() => {
        sidebarCart.find('.SidebarCart__close').first().trigger('focus');
    }, 60);
};

const handleCloseCart = (event) => {
    if (event) {
        event.preventDefault();
    }

    const wasOpen = sidebarCart.hasClass('active');

    sidebarCart.removeClass('active').attr('aria-hidden', 'true');
    $('#main-content').removeClass('blured');
    document.documentElement.classList.remove('SidebarCart-is-open');

    if (wasOpen && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
    }
};

$(document).on('click', '#main-content.blured', handleCloseCart);
$(document).on('click', '.SidebarCart > .SidebarCart__heading .SidebarCart__close', handleCloseCart);
$(document).on('keydown', (event) => {
    if (event.key === 'Escape' && sidebarCart.hasClass('active')) {
        handleCloseCart(event);
    }
});

openCartButton.on('click', handleOpenCart);
$(document.body).on('verenza_open_sidebar_cart', handleOpenCart);

const updateCartItems = ({ announcement = '' } = {}) => {
    sidebarCart.addClass('is-loading');

    return $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'verenza_get_cart_items',
        },
        dataType: 'json',
    })
        .done((response) => {
            const itemCount = Number(response.cart_count) || 0;

            sidebarCart.find('#sidebar-cart-count').html(response.cart_count);
            sidebarCart.find('#sidebar-cart-products-value').html(response.cart_products_value);
            sidebarCart.find('#sidebar-cart-discount').html(response.cart_discount);
            sidebarCart.find('#sidebar-cart-discount-row').prop('hidden', !response.has_discount);
            sidebarCart.find('#sidebar-cart-total').html(response.cart_total);
            sidebarCart.find('.SidebarCart__mainContent').html(response.cart_items);
            sidebarCart.toggleClass('SidebarCart--empty', itemCount < 1);
            updateHeaderCartIndicators(itemCount);

            if (itemCount < 1) {
                couponPanelOpen = false;
            }

            setCouponPanelState(couponPanelOpen);

            if (window.initializeCounters) {
                window.initializeCounters(sidebarCart[0]);
            }

            if (announcement) {
                announce(announcement);
            }
        })
        .fail(() => {
            announce('Nie udało się odświeżyć koszyka. Spróbuj ponownie.');
        })
        .always(() => {
            sidebarCart.removeClass('is-loading');
        });
};

const handleRemoveItemFromCart = (event) => {
    event.preventDefault();

    if (sidebarCart.hasClass('is-loading')) {
        return;
    }

    const button = $(event.currentTarget);
    const productKey = button.attr('data-key');

    sidebarCart.addClass('is-loading');
    button.prop('disabled', true);

    $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'remove_item_from_cart',
            productKey,
        },
    })
        .done(() => {
            $(document.body).trigger('updated_cart_totals');
            $(document.body).trigger('wc_fragment_refresh');
        })
        .fail(() => {
            sidebarCart.removeClass('is-loading');
            button.prop('disabled', false);
            announce('Nie udało się usunąć produktu. Spróbuj ponownie.');
        });
};

$(document).on('click', '.SidebarCart button.remove', handleRemoveItemFromCart);

$(document).on('click', '.SidebarCart__couponToggle', (event) => {
    event.preventDefault();
    const nextState = !couponPanelOpen;

    sidebarCart.find('.SidebarCart__couponStatus').prop('hidden', true).text('');
    setCouponPanelState(nextState, nextState);
});

$(document).on('submit', '.SidebarCart__couponForm', (event) => {
    event.preventDefault();

    const form = $(event.currentTarget);
    const input = form.find('.SidebarCart__couponInput');
    const submit = form.find('.SidebarCart__couponApply');
    const couponCode = String(input.val() || '').trim();

    if (!couponCode) {
        showCouponError('Wpisz kod rabatowy.');
        input.trigger('focus');
        return;
    }

    submit.prop('disabled', true);
    form.addClass('is-submitting');
    form.find('.SidebarCart__couponStatus').prop('hidden', true).text('');

    $.ajax({
        type: 'POST',
        url: jsData.ajaxUrl,
        dataType: 'json',
        data: {
            action: 'verenza_apply_cart_coupon',
            coupon_code: couponCode,
            security: sidebarCart.data('coupon-nonce'),
        },
    })
        .done((response) => {
            if (!response.success) {
                showCouponError(getAjaxMessage(response, 'Nie udało się zastosować tego kodu.'));
                return;
            }

            const message = getAjaxMessage(response, 'Kod rabatowy został zastosowany.');
            couponPanelOpen = false;
            updateCartItems({ announcement: message });
            $(document.body).trigger('wc_fragment_refresh');
        })
        .fail((response) => {
            showCouponError(getAjaxMessage(response, 'Nie udało się zastosować tego kodu.'));
        })
        .always(() => {
            submit.prop('disabled', false);
            form.removeClass('is-submitting');
        });
});

$(document.body).on('added_to_cart updated_cart_totals wc_cart_emptied', () => {
    updateCartItems();
});

const handleCartItemQuantityButton = (event) => {
    event.preventDefault();

    const button = $(event.currentTarget);
    const action = button.data('qty-action');
    const quantityControl = button.closest('.CartItem__quantityControl');
    const select = quantityControl.find('.CartItem__quantity-select');
    const quantityValue = quantityControl.find('.CartItem__quantityValue');
    const currentValue = Number(quantityValue.text()) || Number(select.val()) || 1;
    const nextQty = Math.max(1, Math.min(5, currentValue + (action === 'increase' ? 1 : -1)));

    if (nextQty === currentValue) {
        return;
    }

    quantityValue.text(nextQty);
    select.val(nextQty).trigger('change');
};

$(document).on('click', '.SidebarCart .CartItem__qtyButton', handleCartItemQuantityButton);

$(document).on('change', '.SidebarCart .CartItem__quantity-select', function () {
    const select = $(this);
    const key = select.data('key');
    const rawQty = Number(select.val());
    const qty = Math.max(1, Math.min(5, rawQty || 1));
    const quantityControl = select.closest('.CartItem__quantityControl');

    if (qty !== rawQty) {
        select.val(qty);
    }

    quantityControl.find('.CartItem__quantityValue').text(qty);
    quantityControl.find('.CartItem__qtyButton').prop('disabled', true);
    select.addClass('is-updating');

    $.post(
        jsData.ajaxUrl,
        {
            action: 'verenza_update_cart_quantity',
            cart_item_key: key,
            quantity: qty,
        },
        null,
        'json',
    )
        .done(() => {
            $(document.body).trigger('updated_cart_totals');
        })
        .fail(() => {
            announce('Nie udało się zmienić ilości. Spróbuj ponownie.');
        })
        .always(() => {
            select.removeClass('is-updating');
            quantityControl.find('.CartItem__qtyButton').prop('disabled', false);
        });
});

$(window).on('load', () => {
    sidebarCart.addClass('ready');
});

$(() => {
    if (document.readyState === 'complete') {
        sidebarCart.addClass('ready');
    }

    updateCartItems();
});
